import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Article } from '../../_interfaces/article';
import { HttpFunctionResult } from '../../_interfaces/HttpFunctionResult';
import { HttpService } from '../http.service';
import { TicketEmployee } from '../tickets/ticket.service';
import { Attachment, AttachmentArticle } from '../../_interfaces/Attachment';
import { IProcessBase, ProcessBase, ProcessPosition, ProcessType } from './processes.types';

@Injectable({
  providedIn: 'root'
})
export class ProcessService {

  constructor(
    private http: HttpService
  ) { }

  /**
   * Gibt eine Liste von Vorgängen zurück, die zu einer Adresse gehören.
   * @param {number} addressId Id der Adresse, zu der die Vorgänge gehören.
   * @param {number} typeId Id des Vorgangstyps zum Filtern, -1 für alle Typen.
   * @param {string} searchText Suchtext zum Filtern der Vorgänge.
   * @param {number} offset Offset für die Paginierung der Ergebnisse.
   * @param {number} limit Maximale Anzahl der zurückgegebenen Vorgänge.
   * @returns 
   */
  public async getProcessList(addressId: number, typeId: number = -1, searchText: string = "", offset: number = 0, limit: number = 50): Promise<HttpFunctionResult<ProcessBase[]>> {
    const result: HttpFunctionResult<IProcessBase[]> = await this.http.GET<IProcessBase[]>({
      path: `processes?addressId=${addressId}&typeId=${typeId}&searchText=${encodeURIComponent(searchText)}&offset=${offset}&limit=${limit}`,
    })

    if(!result.success) return result as HttpFunctionResult<ProcessBase[]>;

    return { success: true, data: result.data.map(p => new ProcessBase(p)) }
  }

  /**
   * Gibt einer Liste von Vorgangstypen zurück.
   * @returns 
   */
  public async getTypeList(): Promise<HttpFunctionResult<ProcessType[]>> {
    return await this.http.GET<ProcessType[]>({
      path: 'processes/types'
    })
  }

  /**
   * Gibt einen Vorgang anhand seiner ID zurück.
   * @param {number} id Id des Vorgangs.
   * @returns 
   */
  public async getPositions(processId: number): Promise<HttpFunctionResult<ProcessPosition[]>> {
    return await this.http.GET<ProcessPosition[]>({
      path: `processes/${processId}/positions`
    })
  }


  // public async openProcessExternal(processId: number): Promise<HttpFunctionResult<void>> {



  // }


}
